"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { createContext, useContext } from 'react';
import { DropdownCategoryType } from '../shared.mjs';

const ComboBoxDropdownContext = createContext({
  availableCategories: [],
  activeCategory: DropdownCategoryType.ROOT,
  drillDown: () => {
  },
  drillUp: () => {
  },
  isOptionSelected: () => false,
  optionsPayload: [{ options: [], fallbackOptions: [] }, void 0, "resolved"],
  canUseParentInputSearchValue: false,
  drillDownStackTop: void 0
});
ComboBoxDropdownContext.displayName = "ComboBoxDropdownContext";
function useComboBoxDropdownContext() {
  return useContext(ComboBoxDropdownContext);
}

export { ComboBoxDropdownContext, useComboBoxDropdownContext };
